import { createKeySelector } from 'Lib/reduxUtils';

export const selectOptimistic = createKeySelector('optimistic');
